import { useForm } from "react-hook-form";
import React, { useContext, useEffect, useRef, useState } from "react";
import * as Helper from "../../form/form_inscription_helper";
import * as Pattern from "../../form/form_pattern_helper";
import CustomFieldText from "../../form/CustomFieldText";
import CustomComboBox from "../../form/CustomComboBox";
import CustomUploadField from "../../form/CustomUploadField";
import ReCAPTCHA from "react-google-recaptcha";
import { useTranslation } from 'react-i18next';
import { UserContext } from "../../context/UserContext";

const InscriptionOld = () => {

  const { i18n, t } = useTranslation();

  const { register, handleSubmit, formState: { errors }, setError, setValue, clearErrors, watch } = useForm({ shouldFocusError: true })
  const recaptchaRef = useRef(null)
  const submitRef = useRef(null)

  const [globalError, setGlobalError] = useState("")

  const { login } = useContext(UserContext)

  //watch value
  const vip = watch("vip")
  const password = watch("password")

  const handleFormSubmit = (data) => {

    setGlobalError("")
    submitRef.current.setAttribute("disabled", "disabled")

    //controle recaptcha
    document.getElementById("recaptcha_error").innerHTML = " "
    const recaptcha = recaptchaRef.current.getValue()

    //check recaptcha
    if (recaptcha.length === 0) {
      document.getElementById("recaptcha_error").innerHTML = Helper.EmptyErrorMessages.recaptcha
      submitRef.current.removeAttribute("disabled")
      return false;
    }

    let formData = new FormData()
    formData.append('form', JSON.stringify(data))
    formData.append("recaptcha", recaptcha)
    formData.append("action", "signup")
    formData.append("lang", i18n.language)

    fetch(process.env.REACT_APP_API_URL + '/index.php',
      {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(json => {

        if (json.success === true) {
          window.mixpanelhandler.track("Participation_Form Submitted", { "Result count": 1 })
          //connect user and redirect
          localStorage.setItem("showModalFreeCard", true)
          login(json.data.jwt)
        } else {

          switch (json.message) {
            case "#recaptcha":
              setGlobalError("Veuillez cocher la case \"Je ne suis pas un robot\" pour continuer.")
              break;

            case "#already_email":
              setGlobalError("Un compte existe déjà pour cette adresse e-mail.")
              break;

            case "#already_name":
              setGlobalError("Un compte existe déjà avec ce Nom et ce Prénom.")
              break;

            case "#error":
              setGlobalError("Une erreur est survenue pendant la création de votre compte, merci de re-essayer ultérieurement.")
              break;

            default:
              alert(json.message);
          }

          submitRef.current.removeAttribute("disabled")
          window.grecaptcha.reset()
        }

      });
  }

  const onError = (errors) => {

    Object.entries(errors).some(([key, error]) => {
      if (key.indexOf("optin_") === 0) {
        console.log(document.getElementsByName(key)[0])
        document.getElementById("form_row_wrapper_" + key)?.scrollIntoView({ block: "center" })
      }

      return key.indexOf("optin_") === 0

    })
  };


  return (
    <div className={"strate header footer"} id={"inscriptionStrate"}>
      <div>
        <h1 dangerouslySetInnerHTML={{ __html: t("inscription_inscription") }} />
        <form onSubmit={handleSubmit(handleFormSubmit, onError)}>

          <div className={"form_row_wrapper"} id={"form_row_wrapper_vip"}>
            <div className={"input_wrapper radio"}>
              <label dangerouslySetInnerHTML={{ __html: t("inscription_membre_vip") }} />
              <div>
                <input type={"radio"} id={"vip_yes"} name={"vip"} value={1} {...register("vip")} />
                <label dangerouslySetInnerHTML={{ __html: t("inscription_oui") }} htmlFor={"vip_yes"}/>
              </div>
              <div>
                <input type={"radio"} id={"vip_no"} name={"vip"} value={0} {...register("vip")} />
                <label dangerouslySetInnerHTML={{ __html: t("inscription_non") }} htmlFor={"vip_no"} />
              </div>
            </div>
          </div>

          {vip !== undefined &&
            <>
              <CustomFieldText name="nom" placeholder={t("inscription_nom")} register={register('nom', {
                required: Helper.EmptyErrorMessages.nom,
                pattern: { value: Pattern.alphaPattern, message: Helper.InvalidErrorMessages.nom },
                minLength: { value: 2, message: Helper.InvalidErrorMessages.nom }
              })} error={errors.nom && errors.nom.message} />
              <CustomFieldText name="prenom" placeholder={t("inscription_prenom")} register={register('prenom', {
                required: Helper.EmptyErrorMessages.prenom,
                pattern: { value: Pattern.alphaPattern, message: Helper.InvalidErrorMessages.prenom },
                minLength: { value: 2, message: Helper.InvalidErrorMessages.prenom }
              })} error={errors.prenom && errors.prenom.message} />

              <CustomFieldText name="telephone" placeholder={t("inscription_telephone")} register={register('telephone', {
                required: Helper.EmptyErrorMessages.telephone,
                pattern: { value: Pattern.numberPattern, message: Helper.InvalidErrorMessages.telephone },
                minLength: { value: 10, message: Helper.InvalidErrorMessages.telephone },
                maxLength: { value: 20, message: Helper.InvalidErrorMessages.telephone }
              })} error={errors.telephone && errors.telephone.message} />

              <CustomFieldText name="mail" placeholder={t("inscription_email")}
                register={
                  register("mail", {
                    required: true,
                    pattern: Pattern.emailPattern,
                    validate: {
                      domain: (value) => Helper.checkMailDomain(value)
                    }
                  })}
                error={[
                  errors.mail && errors.mail.type === "required" && Helper.EmptyErrorMessages.mail,
                  errors.mail && errors.mail.type === "pattern" && Helper.InvalidErrorMessages.mail,
                  errors.mail && errors.mail.type === "domain" && Helper.InvalidErrorMessages.mail_domain,
                  errors.mail && errors.mail.type === "confirm" && Helper.InvalidErrorMessages.mail_dif
                ]} />

              <div className={"form_row_wrapper"} id={"form_row_wrapper_optin_age"}>
                <div className={"input_wrapper radio"}>
                  <label dangerouslySetInnerHTML={{ __html: t("inscription_plus_de_18_ans") }} />
                  <div>
                    <input type={"radio"} id={"age_yes"} name={"optin_age"} value={1} {...register("optin_age", {
                      required: Helper.EmptyErrorMessages.optin_age,
                      validate: (value) => value === "1" || Helper.InvalidErrorMessages.optin_age
                    })} />
                    <label htmlFor={"age_yes"} dangerouslySetInnerHTML={{ __html: t("inscription_oui") }} />
                  </div>
                  <div>
                    <input type={"radio"} id={"age_no"} name={"optin_age"} value={2} {...register("optin_age")} />
                    <label htmlFor={"age_no"} dangerouslySetInnerHTML={{ __html: t("inscription_non") }} />
                  </div>
                </div>
                <div className={"error"}>
                  {errors.optin_age && errors.optin_age.message}
                </div>
              </div>

              <CustomFieldText name="password" placeholder={t("inscription_mot_de_passe")} type={"password"}
                register={register("password", { required: Helper.EmptyErrorMessages.password })}
                error={errors.password && errors.password.message}
              />

              <CustomFieldText name="password_confirm" placeholder={t("inscription_mot_de_passe")} type={"password"}
                register={register("password_confirm", {
                  required: Helper.EmptyErrorMessages.password,
                  validate: (value) => {
                    return value === password || Helper.InvalidErrorMessages.password
                  }
                })}
                error={errors.password_confirm && errors.password_confirm.message}
              />

              <div className={"mandatory"} dangerouslySetInnerHTML={{ __html: t("inscription_champs_obligatoires") }} />

              <div className={"optin_container"}>
                <div id={"optin_reglement_wrapper"} className="checkbox_wrapper form_row_wrapper">
                  <input type="checkbox" name="optin_reglement" id="optin_reglement" {...register("optin_reglement", { required: Helper.EmptyErrorMessages.optin_reglement })} />

                  <label htmlFor="optin_reglement" dangerouslySetInnerHTML={{ __html: t("inscription_acceptation_reglement") }} />
                  <div className="error text-center">{errors.optin_reglement && errors.optin_reglement.message}</div>
                </div>

                {vip === "0" &&
                  <div id={"optin_partenaire_wrapper"} className="checkbox_wrapper form_row_wrapper">
                    <input type="checkbox" name="optin_partenaire" id="optin_partenaire" {...register("optin_partenaire")} />
                    <label htmlFor="optin_partenaire" dangerouslySetInnerHTML={{ __html: t("inscription_consentement_communications") }} />
                  </div>
                }

              </div>

              <div id={"rgpd_text_wrapper"}>
                <p dangerouslySetInnerHTML={{ __html: t("inscription_traitement_donnees") }} />
              </div>

              {/* recaptcha */}
              <div className="text-center" id={"recaptcha_wrapper"}>
                <ReCAPTCHA className="d-inline-block" sitekey="6LevKCQhAAAAAErcCcwZpbzQM4R_JcNDUrml4-2b" ref={recaptchaRef} />
                <div className="error text-center" id="recaptcha_error">&nbsp;</div>
              </div>

              {/* server error */}
              <div className="text-center">
                <div className={"error"} id={"global_error"}>
                  {globalError}
                </div>
                <input type={"submit"} id={"submit_cta"} className={"cta gold"} ref={submitRef} value={t("inscription_sinscrire")} />
              </div>
            </>
          }
        </form>
      </div>
    </div>
  )
}

const Inscription = () => {

  const { i18n, t } = useTranslation();

  return (
    <div className={"strate header footer"} id={"inscriptionStrate"}>
      <div>
        <h1 dangerouslySetInnerHTML={{ __html: t("inscription_inscription") }} />
        <p dangerouslySetInnerHTML={{ __html: t("inscription_operation_terminee") }} />
      </div>
    </div>
  )
}

export default Inscription
